export default () => ({
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'auto'
  }
});
